export const adminTokens = {
  color: {
    surface: {
      page: '#F7F7FB',
      raised: '#FFFFFF',
      sunken: '#F0F0F5',
      border: 'rgba(15, 15, 30, 0.08)',
      borderStrong: 'rgba(15, 15, 30, 0.16)',
    },
    text: {
      primary: '#0F0F1E',
      secondary: '#52526B',
      tertiary: '#8585A0',
      inverse: '#FFFFFF',
    },
    brand: {
      50: '#F4ECFF',
      100: '#E5D2FF',
      200: '#CDA8FF',
      300: '#B687FF',
      400: '#A76FFF',
      500: '#8A4BF0',
      600: '#6E33D1',
      700: '#5523A8',
    },
    success: { soft: '#E6F7EF', base: '#0F9D58', text: '#0A6B3C' },
    warning: { soft: '#FFF4DE', base: '#E89C2D', text: '#A56C0D' },
    error:   { soft: '#FFE6E6', base: '#E03E3E', text: '#A11212' },
    info:    { soft: '#E6F0FF', base: '#3578E5', text: '#1B4FAB' },
    chart: ['#A76FFF', '#FF5A76', '#3578E5', '#0F9D58', '#E89C2D', '#5523A8'],
  },
  radius: { sm: 6, md: 10, lg: 14, xl: 20, pill: 999 },
  shadow: {
    sm: '0 1px 2px rgba(15,15,30,0.04), 0 1px 1px rgba(15,15,30,0.03)',
    md: '0 4px 12px rgba(15,15,30,0.06), 0 2px 4px rgba(15,15,30,0.04)',
    lg: '0 12px 32px rgba(15,15,30,0.10), 0 4px 8px rgba(15,15,30,0.04)',
  },
  space: { 1: 4, 2: 8, 3: 12, 4: 16, 5: 24, 6: 32, 7: 48, 8: 64 },
  type: {
    family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Inter, "Helvetica Neue", Arial, sans-serif',
    size: { xs: 12, sm: 14, md: 16, lg: 18, xl: 24, '2xl': 30, '3xl': 36 },
    weight: { regular: 400, medium: 500, semibold: 600, bold: 700 },
    lineHeight: { tight: 1.2, snug: 1.4, normal: 1.55 },
  },
  motion: { fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)', medium: '300ms cubic-bezier(0.4, 0, 0.2, 1)' },
} as const;

export type AdminTokens = typeof adminTokens;
